import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DeterminantesTable = ({
  determinantes,
  setIdDeterminanteEdit,
  setOpenModal
}) => {
  const columns = [
    {
      accessorKey: 'subcliente',
      header: 'Subcliente',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'determinante',
      header: 'Determinante',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'unidad',
      header: 'Unidad',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'formato',
      header: 'Formato',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'municipio',
      header: 'Municipio',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'iddeterminante',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { iddeterminante } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdDeterminanteEdit(iddeterminante);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      {determinantes && (
        <GenericTable
          data={determinantes}
          title="Determinantes"
          columns={columns}
          addAction={() => {
            setIdDeterminanteEdit(0);
            setOpenModal(true);
          }}
        ></GenericTable>
      )}
    </>
  );
};
DeterminantesTable.propTypes = {
  determinantes: PropTypes.array.isRequired,
  setIdDeterminanteEdit: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default DeterminantesTable;
